export default __webpack_public_path__ + "static/media/sound.e1e05f68.mp3";